<template>
  <div class="modal-bg" v-show="show" @click="hideModal">
    <div class="modal-container">
      <div class="modal-header">
        {{ title }}
      </div>
      <div class="modal-main">
        <slot></slot>
      </div>
      <div class="modal-footer">
        <!-- <button @click="hideModal">取消</button> -->
        <button @click="submit">确认</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
  },
  methods: {
    hideModal() {
      this.$emit('hideModal')
    },

    submit() {
      this.$emit('submit')
    },
  }
}
</script>

<style>
.modal-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .5);
  z-index: 100;
}

.modal-container {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 480px;
}

.modal-header {
  height: 56px;
  background: #409EFF;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: move;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 57px;
  border-top: 1px solid #ddd;
}

.modal-footer button {
  width: 100px;
  line-height: 30px;
  padding: 0 15px;
  border-radius: 4px;
  border-width: 1px;
  margin: 20px;
  cursor: pointer;
}

.modal-main {
  padding: 30px 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue